import {LetterAvatarViewProps} from './types'
import React from 'react'
import {isPropsObjectEqual} from 'utils/props'
import {styled} from 'stitches/config'
import {text} from './styles/LetterAvatarView'

const StyledText = styled('div', text)

const LetterAvatarView = (props: LetterAvatarViewProps): React.ReactElement => {
    const {
        shortName, size, state, name,
    } = props
    return (
        <StyledText size={size} state={state} title={name}>
            {shortName}
        </StyledText>
    )
}

LetterAvatarView.defaultProps = {
    size: undefined,
    state: undefined,
}

export default React.memo(LetterAvatarView, isPropsObjectEqual)
